import { createFileRoute } from '@tanstack/react-router';
import { AutomationPageView } from '@/components/marketing/AutomationPage';
import { automationHead } from '@/content/aiAutomation';
export const Route = createFileRoute('/ai-automation/custom-software')({head: () => automationHead('software'), component: SoftwarePage});
function SoftwarePage() { return <AutomationPageView pageKey="software" />; }